"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchCategoryAddon = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../../common/public");
const Combobox_1 = require("../../Combobox");
const Suggest_1 = require("../../../Suggest");
function searchCategoryAddon({ value, options, onChange, size = public_1.CONTROL_SIZE.xs, dropdownWidth }) {
    return function SearchCategoryRenderer({ disabled, blur }) {
        const controlRenderer = (0, react_1.useMemo)(() => (0, Combobox_1.createDefaultControl)({
            buildIn: true,
            iconGetter: ({ option }) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.icon) !== null && _a !== void 0 ? _a : null; }
        }), []);
        const optionRenderer = (0, react_1.useMemo)(() => (0, Suggest_1.createDefaultOption)({
            iconGetter: ({ option }) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.icon) !== null && _a !== void 0 ? _a : null; }
        }), []);
        const comboboxSize = size > public_1.CONTROL_SIZE.l ? public_1.CONTROL_SIZE.l : size;
        const valueGetter = (0, react_1.useCallback)((item) => item.value, []);
        const textGetter = (0, react_1.useCallback)((item) => item.text, []);
        return (react_1.default.createElement(Combobox_1.Combobox, { "data-selector-id": 'search-category', value: value, data: options, disabled: disabled, valueGetter: valueGetter, textGetter: textGetter, controlRenderer: controlRenderer, optionRenderer: optionRenderer, onChange: onChange, size: comboboxSize, onBlur: blur, dropdownWidth: dropdownWidth }));
    };
}
exports.searchCategoryAddon = searchCategoryAddon;
//# sourceMappingURL=searchCategoryAddon.js.map